import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { PublisherThemeConfigProvider, PublisherThemeExtendedChakraProvider } from "theme";
import ContentContainer from "components/Container";
import MobileUploadComponent from "components/CaptureOnMobileButton/MobileUploadComponent";
import uploadConfigs from "./uploadConfigs";
import { AnalyticsProvider, useAnalytics, Analytics } from "utils";

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const MobileUploadPage = () => {
  const analytics = useAnalytics();
  const { roomid } = useParams();
  const query = useQuery();
  const docTypeConfigKey = query.get("docTypeConfigKey");
  const [c] = useState(uploadConfigs[docTypeConfigKey] || {}); // MobileUploadComponent will handle any issues if there's missing info
  const viewEventFired = useRef(false);

  useEffect(() => {
    // useEffect for tracking page view analytic
    if (!viewEventFired.current) {
      analytics.page("CaptureOnMobile", "CaptureOnMobile_MobileUploadPage_Viewed", {
        roomid,
        docTypeConfigKey,
      });
      viewEventFired.current = true;
    }
  }, [analytics, roomid, docTypeConfigKey]);

  return (
    <PublisherThemeConfigProvider>
      <PublisherThemeExtendedChakraProvider>
        <AnalyticsProvider analyticsInstance={Analytics()}>
          <ContentContainer>
            <MobileUploadComponent
              roomid={roomid}
              title={c.title}
              description={c.description}
              items={c.items}
            />
          </ContentContainer>
        </AnalyticsProvider>
      </PublisherThemeExtendedChakraProvider>
    </PublisherThemeConfigProvider>
  );
};

export default MobileUploadPage;
